import {Controls, ControlsItem, Typography} from '@genestack/ui';
import React from 'react';

import styles from './api-access.module.css';

interface Props {
    label: string;
    value?: string;
}

export function CredentialRow({label, value}: Props) {
    return (
        <Controls gap={1}>
            <ControlsItem>
                <Typography as="span" intent="quiet" className={styles.credentialLabel}>
                    {label}:
                </Typography>
            </ControlsItem>
            <ControlsItem>
                <Typography as="span" className={styles.credentialValue}>
                    {value}
                </Typography>
            </ControlsItem>
        </Controls>
    );
}
